import PropTypes from "prop-types";
import Grid from "components/primitives/Grid";
import GlobalSearch from "../GlobalSearch";
import PageContentTitle from "./PageContentTitle";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { useCallback, useState } from "react";
import Modal from "components/Modal";
import logEvent from "utils/logEvent";
import { useTranslation } from "react-i18next";

interface PageContentProps {
  children?: React.ReactNode;
  pageHeading: string;
  pageHeadingLink?: string;
  onPageHeadingBack?: () => void;
  infoCardComponent?: (props: any) => JSX.Element;
}

/**@deprecated Use PageLayout instead */
function PageContent(props: PageContentProps) {
  const {
    pageHeading,
    pageHeadingLink = null,
    onPageHeadingBack,
    infoCardComponent: InfoCardComponent,
    children,
  } = props;
  const { t } = useTranslation();
  const [showInfoCard, setShowInfoCard] = useState(false);

  const toggleInfoCard = useCallback(() => {
    setShowInfoCard((prev) => {
      const updatedValue = !prev;
      if (updatedValue) logEvent("INFO_CARD_VIEW", { page: pageHeading });
      return updatedValue;
    });
  }, [pageHeading]);

  return (
    <>
      <Box sx={{ p: children ? 4 : 0 }}>
        <Grid container spacing="0px" width="100%" alignItems="center">
          <Grid>
            <PageContentTitle title={pageHeading} titleLink={pageHeadingLink} onBack={onPageHeadingBack} />
          </Grid>
          <Grid size="grow">
            {InfoCardComponent && (
              <IconButton
                size="small"
                color="primary"
                onClick={toggleInfoCard}
                aria-label={t("global.view_more_information_label")}
              >
                <InfoOutlined fontSize="small" />
              </IconButton>
            )}
          </Grid>
          <Grid>
            <Grid container alignItems="center" spacing="8px" width="calc(100% + 8px)" p={0}>
              <Grid>
                <Box>
                  <GlobalSearch />
                </Box>
              </Grid>
            </Grid>
          </Grid>
          {children && <Grid size={12}>{props.children}</Grid>}
        </Grid>
      </Box>
      {InfoCardComponent && (
        <Modal open={showInfoCard} toggleOpen={toggleInfoCard}>
          <InfoCardComponent onClose={toggleInfoCard} />
        </Modal>
      )}
    </>
  );
}

PageContent.propTypes = {
  pageHeading: PropTypes.oneOfType([PropTypes.node.isRequired, PropTypes.string.isRequired]).isRequired,
  pageHeadingLink: PropTypes.string,
};

export default PageContent;
